import { cn } from "@/lib/utils";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter, } from "../ui/Dialog/Dialog"
import Image from "../ui/Image/Image";
import { Button } from "../ui/Button/Button";
import { useResponsive } from "@/utils/useResponsive";

export type DialogProps = {
  open: boolean;
  onClose?: () => void;
  header?: React.ReactNode;
  image?: string;
  closeBtn?: boolean;
  title: string;
  subtitle?: string;
  body?: React.ReactNode;
  primaryBtn?: {
    label: string;
    onClick?: () => void;
  },
  secondaryBtn?: {
    label: string;
    onClick?: () => void;
  },
}

export const Modal = (props: DialogProps) => {
  const { open, onClose, header, image, closeBtn, title, subtitle, primaryBtn, secondaryBtn, body } = props;
  const { isMobile } = useResponsive();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="!min-w-[300px] !max-w-[300px] md:!min-w-[500px] md:!max-w-[500px] rounded-[14px] p-[18px]" closeBtn={closeBtn}>
        <DialogHeader>
          {header && <DialogTitle>
            <div className="flex justify-center">
              {header}
            </div>
          </DialogTitle>}

          {image && <Image
            src={image}
            alt="Welcome image"
            className="w-full h-auto object-cover pt-4"
            style={{ marginBottom: 0, marginTop: 0 }}
          />}

          <DialogDescription className="!mt-4 !mb-0">
            <span className={cn('text-headingMedium')}>
              {title}
            </span>
          </DialogDescription>
          <DialogDescription className="!mt-3 !mb-4">
            <span className={cn('text-bodyMedium')}>
              {subtitle}
            </span>
          </DialogDescription>
          {body}
          {(primaryBtn || secondaryBtn) && <DialogFooter className="!mt-0">
            <div
              className={cn('flex flex-row items-center justify-center gap-x-[14px]')}
            >
              {secondaryBtn && <Button
                size={isMobile ? "mobile" : "small"}
                variant="Rounded"
                label={secondaryBtn.label}
                onClick={secondaryBtn.onClick}
              />}
              {primaryBtn && <Button
                size={isMobile && secondaryBtn ? "mobile" : "small"}
                variant="Rounded"
                label={primaryBtn.label}
                primary
                onClick={primaryBtn.onClick}
              />}
            </div>
          </DialogFooter>}
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}